import { forwardRef } from 'react';
import clsx from 'clsx';
import type {
  ComponentPropsWithoutRef,
  HTMLAttributes,
} from 'react';

import style from './form.module.scss';

const FormItem = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => (
  <div
    {...props}
    className={clsx(style.FormItem, className)}
    ref={ref}
  />
));

FormItem.displayName = 'FormItem';

const FormLabel = forwardRef<HTMLLabelElement, ComponentPropsWithoutRef<'label'>>(({
  className,
  htmlFor,
  ...props
}, ref) => (
  <label
    {...props}
    className={clsx(style.FormLabel, className)}
    htmlFor={htmlFor}
    ref={ref}
  />
));

FormLabel.displayName = 'FormLabel';

export {
  FormItem,
  FormLabel,
};
